import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAddLoginMutation } from "../../../../Services/userApi";
import { Notification } from "../../../../components/ToastNotification";
import { savedLocalStorage } from "../../../../utils/function/localStorage";
import "./Login.css";

export let popupShow = false;

const LoginForm = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    rememberMe: false,
  });

  const [addLogin, { error, data, isLoading }] = useAddLoginMutation();

  useEffect(() => {
    if (data?.message) {
      Notification(data?.message, "success");
      popupShow = true;
      savedLocalStorage("grow_boo_token", data?.token);
      navigate("/dashboard");
    } else if (error?.data?.message) {
      Notification(error?.data?.message, "error");
    }
  }, [error, data, navigate]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await addLogin({
      userId: formData.username,
      password: formData.password,
    });
  };

  return (
    <div className="lw">
      {/* bokeh blobs */}
      <div className="l-bokeh l-bokeh--1" aria-hidden="true" />
      <div className="l-bokeh l-bokeh--2" aria-hidden="true" />

      <div className="lc">
        <div className="lcard">
          {/* ── Logo ── */}
          <div className="l-logo">
            <div className="l-logo-circle">
              <img src="/logo.jpeg" alt="Grow Biz International" />
            </div>
            <div className="l-logo-text">
              Grow Biz
              <span>International</span>
            </div>
          </div>

          {/* ── Heading ── */}
          <div className="l-head">
            <h2>Welcome Back</h2>
            <div className="l-gline" />
            <p>Your smart money journey continues here.</p>
          </div>

          {/* ── Form ── */}
          <form onSubmit={handleSubmit} noValidate>
            {/* Username */}
            <div className="l-group">
              <label className="l-label" htmlFor="username">
                UserId or Email <span className="l-req">*</span>
              </label>
              <div className="l-input-wrap">
                <input
                  className="l-input"
                  type="text"
                  id="username"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  placeholder="e.g. ahmad@growbiz.com"
                  autoComplete="username"
                  required
                />
              </div>
            </div>

            {/* Password */}
            <div className="l-group">
              <label className="l-label" htmlFor="password">
                Password <span className="l-req">*</span>
              </label>
              <div className="l-input-wrap">
                <input
                  className="l-input l-input--pass"
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter your password"
                  autoComplete="current-password"
                  required
                />
                <button
                  type="button"
                  className="l-eye"
                  onClick={() => setShowPassword((v) => !v)}
                  aria-label="Toggle password visibility"
                >
                  {showPassword ? "👁️" : "👁️‍🗨️"}
                </button>
              </div>
            </div>

            {/* Submit */}
            <button type="submit" className="l-submit" disabled={isLoading}>
              <span className="l-submit-inner">
                {isLoading && <span className="l-spinner" />}
                {isLoading ? "Logging in..." : "Login"}
              </span>
            </button>

            {/* Links */}
            <div className="l-links">
              <span>Need an account?</span>
              <Link to="/join-us">Register</Link>
              <Link to="/forgot-password">Forgot password?</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
